import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { CartItem } from 'src/app/model/cart';

const SCROLL_LOCK_CLASS = 'is-scroll-locked';

/** Confirmacao da troca: substitui o SweetAlert + reload da versao anterior. */
@Component({
  selector: 'app-store-exchange-success',
  templateUrl: './store-exchange-success.component.html',
  styleUrls: ['./store-exchange-success.component.scss'],
})
export class StoreExchangeSuccessComponent implements OnChanges, OnDestroy {
  @Input() open = false;
  @Input() pointsSpent = 0;
  /** Vem do refetch da carteira, nao de conta local. */
  @Input() newBalance = 0;
  @Input() balanceLoading = false;
  /** Saldo nao pode ser lido: nao inventa um numero sob o rotulo "Novo saldo". */
  @Input() balanceUnknown = false;
  /** Snapshot do que foi trocado, tirado antes de esvaziar o carrinho. */
  @Input() items: CartItem[] = [];
  @Input() protocol = '';

  @Output() backToStore = new EventEmitter<void>();
  @Output() goToStatement = new EventEmitter<void>();

  @ViewChild('primary', { static: false }) primary: ElementRef<HTMLButtonElement>;
  @ViewChild('panel', { static: false }) panel: ElementRef<HTMLElement>;

  constructor(private renderer: Renderer2) {}

  // O painel se declara role="dialog" aria-modal: precisa se comportar como um.
  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.open) {
      return;
    }
    if (this.open) {
      this.renderer.addClass(document.body, SCROLL_LOCK_CLASS);
      setTimeout(() => {
        if (this.primary) {
          this.primary.nativeElement.focus();
        }
      }, 0);
    } else {
      this.renderer.removeClass(document.body, SCROLL_LOCK_CLASS);
    }
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, SCROLL_LOCK_CLASS);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.open) {
      this.backToStore.emit();
    }
  }

  @HostListener('document:keydown.tab', ['$event'])
  @HostListener('document:keydown.shift.tab', ['$event'])
  onTab(event: KeyboardEvent): void {
    if (!this.open || !this.panel) {
      return;
    }
    const focusables = this.panel.nativeElement.querySelectorAll<HTMLElement>(
      'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) {
      return;
    }
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement as HTMLElement;
    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  get totalItems(): number {
    return (this.items || []).reduce((sum, item) => sum + item.quantity, 0);
  }
}
